<script setup lang="ts"></script>

<template>
  <div class="flex w-full flex-col rounded-compact-button bg-[#F9F9F9] p-4 md:p-8">
    <div class="font-bold text-gray-800">
      <slot name="title"></slot>
    </div>
    <div class="flex w-full flex-col gap-y-2">
      <slot></slot>
    </div>
  </div>
</template>

<style scoped></style>
